<template>
  <div class="stat-item">
    <BaseText4 text="Story"/>
    <BaseText6 :text="opponentStory"/>
  </div>
</template>

<script>
import BaseText4 from '@/components/BaseText4/BaseText4'
import BaseText6 from '@/components/BaseText6/BaseText6'
export default {
  props: {
    opponentStory: {
      type: String,
      required: true
    }
  },
  components: {
    BaseText4,
    BaseText6
  }
}
</script>

<style lang="scss" scoped>
.stat-item {
  text-align: left;
}
</style>
